export const shouldShowOtherReports = counts => {
  const showTemplatesReport = typeof counts?.templateCount === "number";
  const showRejectedTemplatesReport =
    typeof counts?.templateRejectedCount === "number";
  return { showTemplatesReport, showRejectedTemplatesReport };
};

export function buildPolicyTypesForSelector({
  counts = {},
  documentLabelPlural,
  t
}) {
  const {
    showTemplatesReport,
    showRejectedTemplatesReport
  } = shouldShowOtherReports(counts);
  const templateSelectorTitle = t(
    "documentReports.expiring.documentTypeSelector.templateTitle",
    { documentLabelPlural }
  );
  const rejectedTemplateSelectorTitle = t(
    "documentReports.expiring.documentTypeSelector.rejectTemplateTitle",
    { documentLabelPlural }
  );
  const policyTypes = [
    {
      key: "timeCount",
      counter: counts?.timeCount,
      name: documentLabelPlural,
      to: "/policy_reports/expiring"
    }
  ];
  if (showTemplatesReport) {
    policyTypes.push({
      key: "templateCount",
      counter: counts?.templateCount,
      name: templateSelectorTitle,
      to: "/policy_reports/expiring/template"
    });
  }
  if (showRejectedTemplatesReport) {
    policyTypes.push({
      key: "templateRejectedCount",
      counter: counts?.templateRejectedCount,
      name: rejectedTemplateSelectorTitle,
      to: "/policy_reports/expiring/template/rejected"
    });
  }
  return policyTypes;
}
